import { getRandomInt } from '../framework/src/helpers';
import * as particles from 'pixi-particles';
import * as PIXI from "pixi.js-legacy";
import Commander from "./Commander";

/**
 *  This class emits lines during bigwin and normal win animations.
 *  Creating lines effect is based upon moving emitter that creates particles on the canvas.
 *  Moving the emitter leaves a trail of particles that create wanted effect.
 *
 * @class
 */
class Emitter {

    constructor(renderer, commander) {
        this.commander = commander;
        this._renderer = renderer;
        this._config = {};

        this.audio = this.commander.audio;

        this._emitterContainers = [];
        this._emitterContainers.push(new PIXI.Container());
        this._emitterContainers.push(new PIXI.Container());

        this.layer = {};
        this.point = {x: 640, y: 360};
        this.point1 = {x: 640, y: 360};
    }

    /**
     * Set this.layer to layer. Create texture for emitters. Create 2 emitters and initialize them.
     * Set their initial position. Add them to layer.
     * @param layer
     */
    create(layer) {
        this.layer = layer;
        this.addMask();
        this._config = emitterConfig;
        this.textures = PIXI.Texture.from("bar_particle.png");

        this._emitter = new particles.Emitter(this._emitterContainers[0], this.textures , this._config);
        this._emitter2 = new particles.Emitter(this._emitterContainers[1], this.textures , this._config);

        this._emitter.emit = false;
        this._emitter2.emit = false;
        this._emitterContainers[0].name = "emiteer1";
        this._emitterContainers[1].name = "emiteer2";

        this._emitter.updateSpawnPos(this.point.x,this.point.y);
        this._emitter2.updateSpawnPos(this.point1.x,this.point1.y);

        this.layer.addChild(this._emitterContainers[0]);
        this.layer.addChild(this._emitterContainers[1]);
    }

    addMask() {
        let mask = new PIXI.Graphics();
        mask.beginFill(0xFFFFFF);
        mask.drawRect(0, 85, 1280, 635);
        mask.endFill();

        this.layer.mask = mask;
    }

    /**
     * Select the right path by number, play win_Combo sound and call {@link Emitter#moveLine} to animate emitters position.
     * If toRight is true, rearrange the path so the initially first point is the last and so on.
     * @param number
     * @param toRight
     * @param length
     */
    emitLine(number, toRight, length) {
        let path;

        switch(number) {
            case 1:
                this.point = {x: 200, y: 395};
                path = [
                    [200,395, 255,440, 310,440],
                    [310,440, 420,350, 530,395],
                    [530,395, 640,440, 750,395],
                    [750,395, 860,350, 970,440],
                    [970,440, 1025,440, 1080,395]
                ];
                break;
            case 2:
                this.point = {x: 200, y: 190};
                path = [
                    [200,190, 255,240, 310,240],
                    [310,240, 420,140, 530,190],
                    [530,190, 640,240, 750,190],
                    [750,190, 860,140, 970,240],
                    [970,240, 1025,240, 1080,190]
                ];
                break;
            case 3:
                this.point = {x: 200, y: 600};
                path = [
                    [200,600, 255,550, 310,550],
                    [310,550, 420,650, 530,600],
                    [530,600, 640,550, 750,600],
                    [750,600, 860,650, 970,550],
                    [970,550, 1025,550, 1080,600]
                ];
                break;
            case 4:
                this.point = {x: 200, y: 190};
                path = [
                    [200,190, 255,190, 310,240],
                    [310,240, 420,292, 530,497],
                    [530,497, 640,650, 750,497],
                    [750,497, 860,292, 970,240],
                    [970,240, 1025,190, 1080,190]
                ];
                break;
            case 5:
                this.point = {x: 200, y: 600};
                path = [
                    [200,600, 255,600, 310,550],
                    [310,550, 420,497, 530,292],
                    [530,292, 640,100, 750,292],
                    [750,292, 860,497, 970,550],
                    [970,550, 1025,600, 1080,600]
                ];
                break;
            case 6:
                this.point = {x: 200, y: 190};
                path = [
                    [200,190, 255,190, 310,190],
                    [310,190, 420,140, 530,240],
                    [530,240, 640,497, 750,240],
                    [750,240, 860,140, 970,190],
                    [970,190, 1025,190, 1080,190]
                ];
                break;
            case 7:
                this.point = {x: 200, y: 600};
                path = [
                    [200,600, 255,600, 310,600],
                    [310,600, 420,650, 530,550],
                    [530,550, 640,292, 750,550],
                    [750,550, 860,650, 970,600],
                    [970,600, 1025,600, 1080,600]
                ];
                break;
            case 8:
                this.point = {x: 200, y: 395};
                path = [
                    [200,395, 255,395, 310,440],
                    [310,440, 420,650, 530,550],
                    [530,550, 640,497, 750,550],
                    [750,550, 860,650, 970,440],
                    [970,440, 1025,395, 1080,395]
                ];
                break;
            case 9:
                this.point = {x: 200, y: 395};
                path = [
                    [200,395, 255,395, 310,350],
                    [310,350, 420,100, 530,240],
                    [530,240, 640,292, 750,240],
                    [750,240, 860,100, 970,350],
                    [970,350, 1025,395, 1080,395]
                ];
                break;
            case 10:
                this.point = {x: 200, y: 395};
                path = [
                    [200,395, 255,350, 310,292],
                    [310,292, 420,100, 530,292],
                    [530,292, 640,497, 750,292],
                    [750,292, 860,100, 970,292],
                    [970,292, 1025,350, 1080,395]
                ];
                break;
            }

            // rearrange path points, path is now backwards
            if (!toRight) {
                for (let i = 0; i < 5; i++) {
                    path[i] = [path[i][4],path[i][5], path[i][2],path[i][3], path[i][0],path[i][1]];
                }
                path.reverse();
                this.audio.playTrack("win_Beam_RL_0"+this.getNumber());
            } else {
                this.audio.playTrack("win_Beam_LR_0"+this.getNumber());
            }

        this.point.toRight = toRight;
        return this.moveLine(path, length);
    }

    /**
     * Return number from range 1 to 3. If the number is equal to this.soundNumber, generate it again.
     * Set soundNumber to that number on return.
     * @return {number}
     */
    getNumber() {
        let number;
        while(true) {
            number = getRandomInt(1,3);
            if (number !== this.soundNumber){
                return this.soundNumber = number;
            }
        }
    }

    /**
     * Create a tween that changes this.point value according to given path and add onChangeEventListener that
     * changes the position of this._emitter to this.point position. Start emitting particles on the beginning and
     * stop after the end.
     * Promise ends after the animation. If the win line is shorter (can be 3, 4 or 5 symbols), call {@link Emitter#endLine} to end animation.
     * @param path
     * @param length {number} length of win line
     * @return {Promise<any>}
     */
    moveLine(path, length) {
        Commander.removeTween(this.point);

        this._emitter.init(this.textures , this._config);
        //this._emitter.updateSpawnPos(this.point.x,this.point.y);

        this._emitter.emit = true;
        return new Promise (res => {
            createjs.Tween.get(this.point)
                .to({guide:{ path: path[0]}}, 40)
                .to({guide:{ path: path[1]}}, 75)
                .to({guide:{ path: path[2]}}, 75)
                .to({guide:{ path: path[3]}}, 75)
                .to({guide:{ path: path[4]}}, 40)
                .call(() => this.endLine(res))
                .addEventListener("change", () => {
                    this._emitter.updateSpawnPos(this.point.x,this.point.y);
                    if (length === 3) {
                        if(this.point.toRight && this.point.x > 640) {
                            this.endLine(res);
                        } else if (!this.point.toRight && this.point.x < 640) {
                            this.endLine(res);
                        }
                    } else if (length === 4) {
                        if(this.point.toRight && this.point.x > 860) {
                            this.endLine(res);
                        } else if (!this.point.toRight && this.point.x < 420) {
                            this.endLine(res);
                        }
                    }
                });
        })
    }

    /**
     * Stop this._emitter from emitting particles. Call callback.
     * @param callback
     */
    endLine(callback) {
        Commander.removeTween(this.point);
        this._emitter.emit = false;
        callback();
    }

    /*
    // point is [x, y]
    // returns array [x, y] with random generated coordinates
    static getRandomPoint(xBorder = 300, point = false) {
        if (point) { // generate point near to the location of point (shift by 400-620 on x and 200-305 on y)
            if (point[0] > xBorder)
                point[0] -= Math.floor(Math.random()*320)+200;
            else
                point[0] += Math.floor(Math.random()*320)+400;
            if (point[1] > 360)
                point[1] -= Math.floor(Math.random()*105)+200;
            else
                point[1] += Math.floor(Math.random()*105)+200;
            return point;
        } else {
            let x = Math.floor(Math.random()*900)+240; // generate number in range 240-1140
            let y = Math.floor(Math.random()*420)+200; // generate number in range 200-620
            return [x, y];
        }
    }
    */
    /*
    getRandomPoints(count) {
        let points = [];
        for (let i = 0; i < count; i++)
            points.push(...this.getRandomPoint());
        return points;
    }
    */

    // animating random lines on bigwin shine
    /**
     * Animating random generate lines on bigwin animation.
     * @param i
     */
    bigWinLines(i) {
        let path1;
        let path2;
        let x;
        switch(x = Math.round(Math.random()*10)) {
            case 0:
                path1 = [
                    [985, 292, 641, 588, 157, 319],
                    [157, 319, 728, 564, 309, 300],
                    [309, 300, 887, 548, 429, 327]
                ]; 
                path2 = [
                    [200, 600, 683, 318, 290, 609],
                    [290, 609, 1008, 370, 637, 141],
                    [637, 141, 1073, 352, 815, 655]
                ];
                break;
            case 1:
                path1 = [
                    [964, 547, 658, 255, 219, 533],
                    [219, 533, 916, 272, 574, 482],
                    [574, 482, 1196, 255, 905, 538]
                ]; 
                path2 = [
                    [982, 400, 595, 197, 105, 371],
                    [105, 371, 614, 167, 125, 358],
                    [125, 358, 557, 630, 203, 364]
                ];
                break;
            case 2:
                path1 = [
                    [200, 395, 728, 113, 502, 326],
                    [502, 326, 1148, 537, 921, 242],
                    [921, 242, 552, 532, 181, 310]
                ]; 
                path2 = [
                    [200, 395, 867, 191, 516, 344],
                    [516, 344, 950, 583, 441, 354],
                    [441, 354, 899, 581, 666, 314]
                ];
                break;
            case 3:
                path1 = [
                    [417, 374, 986, 169, 552, 447],
                    [552, 447, 1165, 218, 834, 466],
                    [834, 466, 505, 169, 141, 468]
                ]; 
                path2 = [
                    [380, 393, 967, 108, 602, 323],
                    [602, 323, 1219, 539, 768, 333],
                    [768, 333, 332, 537, 1047, 239]
                ];
                break;
            case 4:
                path1 = [
                    [200, 395, 828, 106, 360, 335],
                    [360, 335, 820, 601, 491, 301],
                    [491, 301, 899, 575, 594, 305]
                ]; 
                path2 = [
                    [970, 548, 516, 292, 175, 564],
                    [175, 564, 673, 340, 258, 628],
                    [258, 628, 934, 411, 516, 140]
                ];
                break;
            case 5:
                path1 = [
                    [564, 438, 1060, 151, 842, 439],
                    [842, 439, 482, 161, 230, 383],
                    [230, 383, 692, 102, 191, 400]
                ]; 
                path2 = [
                    [386, 385, 975, 178, 744, 402],
                    [744, 402, 353, 159, 148, 377],
                    [148, 377, 581, 109, 334, 381]
                ];
                break;
            case 6:
                path1 = [
                    [200, 600, 837, 310, 343, 607],
                    [343, 607, 1046, 351, 781, 574],
                    [781, 574, 314, 315, 964, 547]
                ]; 
                path2 = [
                    [762, 240, 485, 454, 194, 169],
                    [194, 169, 850, 398, 483, 175],
                    [483, 175, 927, 472, 634, 235]
                ];
                break;
            case 7:
                path1 = [
                    [490, 329, 1113, 532, 665, 244],
                    [665, 244, 1280, 475, 903, 225],
                    [903, 225, 510, 511, 109, 295]
                ]; 
                path2 = [
                    [964, 244, 497, 468, 177, 257],
                    [177, 257, 671, 527, 265, 241],
                    [265, 241, 695, 452, 480, 199]
                ];
                break;
            case 8:
                path1 = [
                    [262, 533, 896, 244, 380, 494],
                    [380, 494, 847, 224, 525, 511],
                    [525, 511, 975, 222, 731, 523]
                ]; 
                path2 = [
                    [457, 323, 1120, 610, 734, 392],
                    [734, 392, 374, 188, 176, 327],
                    [176, 327, 567, 572, 220, 371]
                ];
                break;
            case 9:
                path1 = [
                    [506, 432, 928, 186, 564, 437],
                    [564, 437, 1218, 231, 861, 446],
                    [861, 446, 342, 189, 879, 398]
                ]; 
                path2 = [
                    [383, 358, 1024, 580, 673, 380],
                    [673, 380, 1209, 191, 846, 345],
                    [846, 345, 591, 590, 333, 294]
                ];
                break;
            case 10:
                path1 = [
                    [696, 304, 1192, 536, 768, 237],
                    [768, 237, 559, 465, 300, 255],
                    [300, 255, 763, 509, 542, 265]
                ]; 
                path2 = [
                    [778, 269, 335, 482, 903, 237],
                    [903, 237, 699, 535, 420, 303],
                    [420, 303, 893, 543, 565, 257]
                ];
                break;
        }

        if (i > 0) {
            this.moveRandomLine(path1, this.point, false);
            this.moveRandomLine(path2, this.point1, true).then(() => this.bigWinLines(--i));
        }
    }

/*
    // init this.point and return 2dimensional array of points that create random path
    composePath() {
        let point = this.getRandomPoint();
        this.point = {x: point[0], y: point[1]};
        let path = [[],[],[]];
        for (let i = 0; i < 3; i++) {
            path[i].push(...point);
            for (let j = 0; j < 2; j++) {
                path[i].push(...this.getRandomPoint(700/(j+1),[path[i][j*2], path[i][j*2+1]]));
            }
            point = [path[i][4], path[i][5]];
        }
        return path;
    }
*/
    /**
     * Create a tween that animates given point and adds onChange EventLisener that updates the position
     * of emitter. If isSecond is set, position of this._emitter2 is changed, else we change the position of this._emitter.
     * Start emitting on the beginning and stop at the end. Remove tween and end returned promise afterwards.
     * @param path
     * @param point
     * @param isSecond
     * @return {Promise<any>}
     */
    moveRandomLine(path, point, isSecond) {
        Commander.removeTween(point);
        let emitter = isSecond ? this._emitter : this._emitter2;
        emitter.init(this.textures , this._config);
        emitter.updateSpawnPos(path[0][0],path[0][1]);
        emitter.emit = true;

        return new Promise (res => {
            createjs.Tween.get(point)
                .to({guide:{ path: path[0]}}, 300)
                .to({guide:{ path: path[1]}}, 300)
                .to({guide:{ path: path[2]}}, 300)
                .call(() => {
                    Commander.removeTween(point);
                    emitter.emit = false;
                    res();
                })
                .addEventListener("change", () => {
                    emitter.updateSpawnPos(point.x,point.y);
                });
        })
    }

    /**
     * clears particles
     */
    destroy() {
        //this._emitter.destroy();
        //this._emitter = null;
        this._clear();
    }

    /**
     * Reset SpriteRenderer's batching to fully release particles for GC
     * @private
     */
    _clear() {
        if (this._renderer.plugins && this._renderer.plugins.sprite && this._renderer.plugins.sprite.sprites) {
            this._renderer.plugins.sprite.sprites.length = 0;
        }
    }

    cleanUp() {
        this._emitter.cleanup();
        this._emitter2.cleanup();
    }

    static getDirection(lineWin) {
        return lineWin.position[0][0] === 0;
    }
}
let emitterConfig = {
    "autoUpdate": true,
    "alpha": {
        "start": 1,
        "end": 0
    },
    "scale": {
        "start": 1,
        "end": 0,
        "minimumScaleMultiplier": 1
    },
    "color": {
        "start": "#FFFFFF",
        "end": "#FFFFFF"
    },
    "speed": {
        "start": 0,
        "end": 0,
        "minimumSpeedMultiplier": 1
    },
    "acceleration": {
        "x": 6,
        "y": 0
    },
    "maxSpeed": 0,
    "startRotation": {
        "min": 0,
        "max": 0
    },
    "noRotation": false,
    "rotationSpeed": {
        "min": 0,
        "max": 0
    },
    "lifetime": {
        "min": 0.17,
        "max": 0.2
    },
    "blendMode": "normal",
    "frequency": 0.001,
    "emitterLifetime": -1,
    "maxParticles": 500,
    "pos": {
        "x": -10,
        "y": -10
    },
    "addAtBack": false,
    "spawnType": "circle",
    "spawnCircle": {
        "x": 0,
        "y": 0,
        "r": 0
    }
};
export default Emitter;